import { Box, styled } from '@mui/material';

export const EmployeeContributionBoxStyled = styled(Box)(() => ({
  width: '60%',
  '@media (max-width: 820px)': {
    width: 'auto',
  },
}));

export const EmployerContributionBoxStyled = styled(Box)(() => ({
  width: '40%',
  background: '#FBFBFB',
  '@media (max-width: 820px)': {
    width: 'auto',
  },
}));

export const TotalContributionBoxStyled = styled(Box)(() => ({
    boxShadow: "0px 1px 10px 0px #0000003D",
    "> div:first-child": {
        borderBottom: "1px solid #e0e0e0"
    },
    '@media (min-width: 820px)': {
        textAlign: "right",
      }

}));

export const TotalContributioRowStyled = styled(Box)(() => ({
  '@media (min-width: 820px)': {
    fontSize: '32px',
  },
  '@media (max-width: 820px)': {
    fontSize: '24px',
  },
}));

// Adjust contribution Component styles
export const AdjustContributionBannerStyles = styled(Box)({
  border: '1px solid #495867',
  boxShadow: ' 2px 4px 6px 0px #32323280',
  background: '#FFFFFF',
  borderLeftWidth: '44px',
  borderLeftColor: 'background: #495867',
  padding: '12px',
  color: ' #212935',
  textAlign: 'left',
});
